// extracted by mini-css-extract-plugin
module.exports = {"truncate":"Truncate_truncate__AsYDF"};